import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';

export const testingCompletedDefaultValues = { 
  status: ''
};

const testingCompletedSchema = yup.object({
  status: yup.string().required('Please select a test status.')
});

export function useTestingCompletedForm() {
  return useForm<{ status: string }>({
    mode: 'onChange',
    resolver: yupResolver(testingCompletedSchema),
    defaultValues: testingCompletedDefaultValues
  });
}